import React from "react";
import { useNavigate } from "react-router-dom";
import { extractDate } from "../../Components/Functions/date.fun";
import CustomViewButton from "../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  "Date of Creation",
  "Name",
  "Contact Number",
  "Enroll Date",
  "Generated By",
  "Actions",
];

const SiUpdateTable = ({ data, currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/si-updates/view/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id}>
                <td>{Index}</td>
                <td>{extractDate(item?.createdAt) || "N/A"}</td>
                <td>{item?.name || "N/A"}</td>
                <td>{item?.contactNumber || "N/A"}</td>
                <td>{item?.enrollDate || "N/A"}</td>
                <td>{item?.generatedBy || "N/A"}</td>
                <td>
                  <CustomViewButton onClick={() => goToView(item?.id)}></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SiUpdateTable;
